export const TransactionEndpoints = {
  ScheduleInvestment: 'Investments/ScheduleInvestment',
  UpdateInvestment: 'Investments/UpdateInvestment',
  SaveInvestment: 'Investments/SaveInvestment',
  ConfirmInvestment: 'Investments/ConfirmInvestment',
  CancelInvestment: 'Investments/CancelInvestment',
  EditInvestmentRequest: 'Investments/EditInvestmentRequest',
  DeleteInvestment: 'Investments/DeleteInvestment',
  UpdateProgramToStartingBalTransaction:
    'Investments/UpdateProgramToStartingBalTransaction',
  GetStartingBalanceDetails: 'Investments/GetStartingBalanceDetails',
  EditPDFFiles: 'Payments/EditPdfFiles',
  SchedulePayment: 'Payments/SchedulePayment',
  GetPayment: 'Payments/GetPayment',
  UpdatePayment: 'Payments/UpdatePayment',
  CancelPayment: 'Payments/CancelPayment',
  DeletePayment: 'Payments/DeletePayment',
  GetExpense: 'Payments/GetExpense',
  UpdateExpense: 'Payments/UpdateExpense',
  UpdateCredit: 'Credits/UpdateCredits',
  UpdateDeposit: 'Deposits/UpdateDeposits',
  UpdateRefund: 'Refunds/UpdateRefunds',
  UpdateInternalTransfer: 'Transfers/UpdateInternalTransfer',
  PreviewQBOAttachment: 'Payments/PreviewQBOAttachment',
  GetInvoiceURL: 'Transactions/GetSummaryURI',
} as const;
